<template>
	<div class="tabWrapper wrapAccountTabStatementsItems">
		<div class="main">
			<statements-manager
					v-if="isManager"
					:user="user"
					:is-general-title="false"
			/>

			<statements-safety
					v-else-if="isSafety"
					:id="idComputed"
					:user="user"
					:is-general-title="false"
			/>

			<statements-dispatch
					v-else-if="isDispatch"
					:id="idComputed"
					:user="user"
					:is-general-title="false"
			/>

			<statements-all
					v-else
					:id="idComputed"
					:user="user"
					:is-general-title="false"
			/>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import StatementsDispatch from "@/pages/UserProfile/Tabs/Statements/StatementsDispatch.vue";
import StatementsSafety from "@/pages/UserProfile/Tabs/Statements/StatementsSafety.vue";
import StatementsAll from "@/pages/UserProfile/Tabs/Statements/StatementsAll.vue";
import StatementsManager from "@/pages/UserProfile/Tabs/Statements/StatementsManager.vue";

export default {
	name: "AccountTabStatementsItems",
	components: {
		StatementsManager,
		StatementsSafety,
		StatementsAll,
		StatementsDispatch
	},
	props: {
		user: {
			type: Object,
			default: () => ({})
		},
		isManagerTab: {
			type: Boolean,
			default: false
		},
		isSafetyTab: {
			type: Boolean,
			default: false
		},
		isDispatchTab: {
			type: Boolean,
			default: false
		},
	},
	computed: {
		...mapGetters([
			'userProfileMyInfo',
		]),

		idComputed() {
			const { id, department_id, dispatcher_id } = this.user;
			return department_id === 7 ? dispatcher_id : id;
		},

		isManager() {
			return this.isManagerTab || [ 3, 4, 5 ].includes(this.user.department_id);
		},

		isSafety() {
			return this.isSafetyTab || this.user.department_id === 1;
		},

		isDispatch() {
			return this.isDispatchTab || this.user.department_id === 7;
		},
	},
};
</script>

<style scoped lang="scss"></style>
